import {useState, useEffect, useRef, useCallback} from "react";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {LayoutChild} from "../../../../palette/Palette";
import {Animated} from "react-animated-css";
import DriversManagementGrid from "./DriversManagementGrid";
import ManagementForm from "./ManagementForms";
import ManagementFormEdit from "./ManagemetFormEdit";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function DriversManagement(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany,} = DataStore
    const {routesSchedulesControl} = ControlStore

    const [load, setLoad] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [dataEdit, setDataEdit] = useState({})
    const [triggerEdit, setTriggerEdit] = useState(false);

    const isMounted = useMountedState()

    useEffect(() => {
        const GetDriverManagement = async () => {
            const newArray = [];
            let ID = 0;
            console.log(idCompany ,companyName)

            await db.collection(companyName).doc(idCompany).collection('DriverManagement')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            console.log(doc.data())
                            const plateNumber = doc.data().vehicleData.plateNumber.toUpperCase()
                            ID = ID + 1;
                            const obj = {...doc.data(), id: doc.id, ID: ID, plateNumber};
                            console.log(obj)
                            newArray.push(obj);
                        } else {
                            setDataSource([]);
                        }
                    });
                    setDataSource(newArray);
                    setLoad(true)
                })
                .catch(function (e) {
                    console.log(e)
                    setLoad(true)
                    setDataSource(newArray);
                });
        };
        if (isMounted()) {
            GetDriverManagement().catch(() => setTrigger(!trigger));
        }
    }, [companyName, idCompany, isMounted, trigger]);

    return (
        <>
            {!routesSchedulesControl &&
            <LayoutChild percent={95} margin='auto'>
                <VerticalSpace space={25}/>
                <Alerts severity="warning" body={'Debe crear las rutas y horarios!'}/>
            </LayoutChild>}


            {(routesSchedulesControl && visibleGrid) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <DriversManagementGrid load={load} dataSource={dataSource} setEdit={setEdit}
                                       setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                       setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                                       trigger={trigger}/>
            </Animated>}


            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <ManagementForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                DataStore={DataStore} setVisibleGrid={setVisibleGrid} ControlStore={ControlStore}
                                dataDriversArray={dataSource} visibleForm={visibleForm}
                />
            </Animated>}

            {edit &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <ManagementFormEdit setTrigger={setTrigger} trigger={trigger} DataStore={DataStore}
                                    dataEdit={dataEdit} setVisibleGrid={setVisibleGrid} setEdit={setEdit}
                                    dataSource={dataEdit} triggerEdit={triggerEdit} dataDriversArray={dataSource}
                                    setDataEdit={setDataEdit}
                />
            </Animated>
            }
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(DriversManagement));
